<template>
    <div>

        <div class="app-title">
            <div>
                <h1>{{ $t("lbl.user") }}</h1>
            </div>
        </div>

        <section class="app-content">
            <div class="card-columns">
                <div class="card">
                    <h3 class="card-header text-center"><span
                        class=" text-primary">{{ $t('lbl.user.userCenter') }}</span></h3>
                    <ul class="user-info">
                        <li><i class="fas fa-user"> {{ $t('lbl.user.name') }}</i>
                            <div class="user-right">{{ user.userName }}</div>
                        </li>
                        <li><i class="fas fa-user"> {{ $t('lbl.user.loginName') }}</i>
                            <div class="user-right">{{ user.loginName }}</div>
                        </li>
                        <li><i class="fas fa-building"> {{ $t('lbl.user.departmentName') }}</i>
                            <div class="user-right">{{ user.deptName }}</div>
                        </li>
                        <!--                    <li><i class="fas fa-mobile"> {{$t('lbl.user.mobile')}}</i> <div class="user-right" >{{user.mobile}}</div></li>-->
                        <!--                    <li><i class="fas fa-envelope"> {{$t('lbl.user.mail')}}</i> <div class="user-right">{{user.mail}}</div></li>-->
                        <!--<li><i class="fas fa-calendar-minus"> {{$t('lbl.user.createDate')}}</i> <div class="user-right">2019-10-17</div></li> -->
                        <li><i class="fas fa-user-lock"> {{ $t('lbl.user.security') }}</i>
                            <div class="user-right">
                                <em-button type="changePwd" show-name v-bind:class="'btn btn-primary'"
                                           v-on:click="changePassword"></em-button>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import EmButton from "@/components/em/EmButton";
// import { fields} from "@/model/adm/UserSetting";
// const {mapFields} = createHelpers({
//     getterType: 'userSetting/getField',
//     mutationType: 'userSetting/updateField',
// });

export default {
    name: "emUserCenter",
    data() {
        return {
            user: []
        }
    },
    methods: {
        changePassword() {
            this.$router.push('/em/admin/changePassword')
        }
    },
    components: {
        EmButton
    },
    created() {
        this.$store.dispatch("api/get", {
            url: this.$store.state.emAclUser.baseModuleUrl + "/emAclUser/currentUser"
        }, {
            root: true
        }).then(data => {
            this.user = data;
            if (this.$route.query.force) {
                this.changePassword();
            }
        })
    },
    beforeUpdate() {
        if (this.user && this.$route.query.force) {
            this.changePassword();
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.avatar-uploader-icon {
    font-size: 28px;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
    border-radius: 50%
}

.user-info {
    padding: 15px;
    list-style: none;

    li {
        border-bottom: 1px solid #F0F3F4;
        border-top: 1px solid #F0F3F4;
        padding: 11px 0px;
        font-size: 13px;
    }

    .user-right {
        float: right;

        a {
            color: #317EF3;
        }
    }
}
</style>
